/* @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';
import { useEffect, useState } from 'react';

import { Grid, breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import type { CoursesInformationFragment } from 'bundles/premium-certificate/__generated__/contentfulTypes';
import CertificateCourse from 'bundles/premium-certificate/components/mastertrack/CertificateCourse';
import Container from 'bundles/xddp/components/shared/Container';

type Props = CoursesInformationFragment;

const styles: Record<string, Interpolation<Theme>> = {
  certificateCoursesWrapper: () => css`
    background-color: var(--cds-color-grey-25);
    padding: 3rem 0.75rem 4.5rem 0.75rem;
    ${breakpoints.down('sm')} {
      padding-bottom: 3rem;
    }
  `,
  courseListWrapper: css`
    & > div:first-of-type {
      margin-top: 0;
    }
  `,
  coursesTitle: () => css`
    font-family: inherit;
    font-weight: 700;
    font-size: 1.5rem;
    line-height: 1.875rem;
    text-align: center;
    padding-bottom: 4rem;
    ${breakpoints.down('sm')} {
      padding-bottom: 1.25rem;
      text-align: left;
    }
  `,
};

const CertificateCourses = ({ coursesTitle, coursesListCollection }: Props) => {
  /* add isMobileScreen to check if a user is on mobile size small screen. */
  const [isMobileScreen, setisMobileScreen] = useState(true);
  useEffect(() => {
    setisMobileScreen(window.innerWidth < breakpoints.values.md);
  }, []);
  if (!coursesListCollection?.items?.length) {
    return null;
  }

  const coursesList = coursesListCollection.items;
  const courseTotal = coursesList.length;
  return (
    <div id="courses" data-test="CertificateCourses" css={styles.certificateCoursesWrapper}>
      <Container>
        <Grid container justifyContent="center">
          <Grid item>
            {coursesTitle && (
              <h2 data-test="courses-title" css={styles.coursesTitle}>
                {coursesTitle}
              </h2>
            )}
          </Grid>
        </Grid>
        <div css={styles.courseListWrapper}>
          {coursesList &&
            coursesList.map((course, index) => (
              <CertificateCourse
                title={course?.title}
                whatYouWillLearn={course?.whatYouWillLearn}
                projects={course?.projects}
                description={course?.description}
                index={index}
                courseTotal={courseTotal}
                isMobileScreen={isMobileScreen}
                key={course?.title}
              />
            ))}
        </div>
      </Container>
    </div>
  );
};

export default CertificateCourses;
